@if (type === 'monthYear') {
  <span class="text-break col-12">
    <ng-container>
      {{ value ? (value | MonthYearFormat) : ''}}&nbsp;
    </ng-container>
  </span>
}